var _$20$30$40$50$60$;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (_$20$30$40$50$60$ = {}, _defineProperty(_$20$30$40$50$60$, 10, '#e8f4fa'), _defineProperty(_$20$30$40$50$60$, 20, '#bbe5fa'), _defineProperty(_$20$30$40$50$60$, 30, '#8dd4f7'), _defineProperty(_$20$30$40$50$60$, 40, '#53baed'), _defineProperty(_$20$30$40$50$60$, 50, '#229ad6'), _defineProperty(_$20$30$40$50$60$, 60, '#0c7bb3'), _defineProperty(_$20$30$40$50$60$, 70, '#066391'), _defineProperty(_$20$30$40$50$60$, 80, '#064d70'), _defineProperty(_$20$30$40$50$60$, 90, '#093952'), _defineProperty(_$20$30$40$50$60$, 100, '#0c2938'), _$20$30$40$50$60$);